import { render, staticRenderFns } from "./UserInputButton.vue?vue&type=template&id=4a4f496d&scoped=true&"
import script from "./UserInputButton.vue?vue&type=script&lang=js&"
export * from "./UserInputButton.vue?vue&type=script&lang=js&"
import style0 from "./UserInputButton.vue?vue&type=style&index=0&id=4a4f496d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f496d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
